import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    lineBroadcastJobData: {
      contents: [],
      cursor: {},
      isLast: false,
    },
  },
  getters: {
    lineBroadcastJobData: (state) => state.lineBroadcastJobData,
  },
  actions: {
    loadLineBroadcastJobData(context, params) {
      return new Promise((resolve, reject) => {
        alice
          .getLineBroadcastJob(params)
          .then((response) => {
            const { data } = response.data;
            const responseData = {
              contents: context.state.lineBroadcastJobData.contents.concat(data.contents),
              cursor: data.cursor,
              isLast: data.isLast,
              numberOfElements: data.numberOfElements,
              totalElements: data.totalElements,
            };
            context.commit('setLineBroadcastJobData', responseData);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createLineBroadcastJob(context, params) {
      return new Promise((resolve, reject) => {
        alice
          .createLineBroadcastJob(params)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    clearLineBroadcastJobData(context) {
      const initData = {
        contents: [],
        cursor: {},
        isLast: false,
      };
      context.commit('setLineBroadcastJobData', initData);
    },
    deleteLineBroadcastJob(context, params) {
      return new Promise((resolve, reject) => {
        alice
          .deleteLineBroadcastJob(params)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    archiveLineBroadcastJob(context, params) {
      return new Promise((resolve, reject) => {
        alice
          .archiveLineBroadcastJob(params)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkAutomaticArchive() {
      return new Promise((resolve, reject) => {
        alice
          .checkAutomaticArchive()
          .then((response) => {
            const { data } = response.data;
            console.log(data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    setLineBroadcastJobData(state, data) {
      Vue.set(state, 'lineBroadcastJobData', data);
    },
  }
};
